<template>
    <div>
        <template v-if="app.template.type === '92fanli'">
            <NTfanliTopFreeLIst
                    :title="title"
                    :style-name="app.template.style"
                    :list="goodsData.list"
                    :recommend-list="recommendList"
                    ref="goodsList" />
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <DamaiTopFreeLIst
                    :title="title"
                    :style-name="app.template.style"
                    :list="goodsData.list"
                    :recommend-list="recommendList"
                    ref="goodsList" />
        </template>
        <template v-else>
            <IfanliTopFreeLIst
                    :title="title"
                    :style-name="app.template.style"
                    :list="goodsData.list"
                    :recommend-list="recommendList"
                    ref="goodsList" />
        </template>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import IfanliTopFreeLIst from './ifanli/TopFreeLIst';
    import NTfanliTopFreeLIst from './92fanli/TopFreeLIst';
    import DamaiTopFreeLIst from './damai/TopFreeLIst';
    import {isMobile} from '../libs/utils';

    export default {
        components: {IfanliTopFreeLIst, NTfanliTopFreeLIst, DamaiTopFreeLIst},
        data() {
            return {
                title: '礼金专区',
                goodsData: {
                    list: [],
                    pageNum: 1
                },
                recommendList: [],
                shareStatus: false
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/goods/free';
            }
            this.fetchGoodsList();
            this.fetchRecommendList();
        },
        methods: {
            fetchGoodsList: function () {
                let self = this;

                appService.fetchTopTljs({limit: 8}).then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.goodsData.list = data;
                    }
                });
            },
            fetchRecommendList: function () {
                let self = this;

                appService.fetchRecommendList().then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.recommendList = data;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
